import { Link } from 'react-router-dom';
import styles from './SectionLink.module.scss';
import cn from 'classnames';

interface ILinkProps {
  title: string;
  link: string;
  className?: string;
}

export const SectionLink = ({ title, link, className }: ILinkProps) => {
  return (
    <Link to={link} className={cn(styles.link, className)}>
      {title}
    </Link>
  );
};
